import React from "react";
import "./styles.less";
import { useTranslation } from "react-i18next";
import { Title } from "../../components/NewTitle";
import { CommonConsult } from "../common-consult";

export const AuthorityModel = ({ dataRows, vueLink } = {}) => {
  const { t } = useTranslation();
  const cardText = [
    {
      title: t("learn.authority.model.item1.title"),
      lists: [
        t("learn.authority.model.item1.list1"),
        t("learn.authority.model.item1.list2"),
        t("learn.authority.model.item1.list3"),
      ],
    },
    {
      title: t("learn.authority.model.item2.title"),
      lists: [
        t("learn.authority.model.item2.list1"),
        t("learn.authority.model.item2.list2"),
        t("learn.authority.model.item2.list3"),
      ],
    },
  ];
  return (
    <div className="authority-model">
      <div className="inner">
        <Title title={t("learn.authority.model.title")} align="left"></Title>
        <div className="home-api-card-warp">
          {cardText.map((item) => (
            <div className="home-api-card">
              <div className="card-title">{item.title}</div>
              {item.lists.map((list) => (
                <div className="card-list">{list}</div>
              ))}
              <CommonConsult
                aside={
                  <div className="card-button">
                    {t("common.common-consult")}
                  </div>
                }
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
